<template>
  <el-drawer
  title="Rabais"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :append-to-body="true"
  :close-on-click-modal="false"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form :model="rebate" ref="rebateCreditForm" :rules="rules" label-position="top">
      <!-- <el-form-item label="Prix">
        <el-radio-group v-model="rebate.priceLabel">
          <el-radio v-for="p in itemPrices" :label="p.label">{{p.label}} ({{p.price}})</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-divider/> -->
      <!-- Credit -->
      <div v-if="type=='CREDIT'">
        <el-form-item :label="$t('rebates.rebateType')" prop="creditType" >
          <el-select v-model="rebate.creditType" :placeholder="$t('common.select.placeholder')">
            <el-option
              v-for="item in rebate_types"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <h5>{{$t('rebates.detail')}}</h5>
      <el-row class="m-10">
        <span class="fs-14 secondary-text">{{$t('rebates.rapideSelection')}} </span>
        <el-button type="primary" plain size="mini" @click="handleQuickRebate(5)">5%</el-button>
        <el-button type="primary" plain size="mini" @click="handleQuickRebate(10)">10%</el-button>
        <el-button type="primary" plain size="mini" @click="handleQuickRebate(15)">15%</el-button>
        <el-button type="primary" plain size="mini" @click="handleQuickRebate(20)">20%</el-button>
        <el-button type="primary" plain size="mini" @click="handleQuickRebate(100)">100%</el-button>
      </el-row>
      <el-form-item :label="$t('rebates.definition')">
        <el-row>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-input-number v-model="rebate.value" :min="0" :controls="false" style="max-width:120px"></el-input-number>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-select v-model="rebate.type" style="width:80px;" @change="handleRebateTypeChange">
              <el-option
                v-for="item in [{id:1,label:'%'}, {id:2,label:'$'}]"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item v-if="showNetType">
        <el-radio-group v-model="rebate.netType" :disabled="rebate.type!=2">
          <el-radio label="UNIT" border>{{ $t('rebates.perUnit') }}</el-radio>
          <el-radio label="TOTAL" border>{{ $t('rebates.total') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
  <div class="dialog-footer card-shadow--large">
    <el-button @click="handleClose">{{ $t('common.Cancel') }}</el-button>
    <el-button type="primary" @click="save">{{ $t('common.apply') }}</el-button>
  </div>
</el-drawer>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import store from '../store/store'

export default {
  name: 'SalesOrder-Rebate-Credit-SalesOrder',
	props: {
    itemUuid : {type : String},
    visible : {type : Boolean},
    rebateToEdit : {type : Object},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    },
    showNetType : {
      type: Boolean,
      default: true
    }
	},
  data() {
    return {

      type : "CREDIT",
      options : [{id:1,label:'%'}, {id:2,label:'$'}],
      rebate : {
        value : null,
        type : 1,
        netType : 'TOTAL',
        creditType : null,
        priceLabel : null,
      },
      rules : {
        creditType : [
          { required: true, message: 'Veuillez sélectionner le type de crédit', trigger: 'blur' },
        ]
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },components: {

  },
  watch : {

  },
	methods: {
    handleQuickRebate (percent) {
      this.rebate.value = percent;
      this.rebate.type=1;
      this.rebate.netType="TOTAL",
      this.type="CREDIT";
    },
    reset(){
      this.rebate.value = null;
      this.rebate.type=1;
      this.rebate.netType="TOTAL",
      this.rebate.creditType=null;
      this.type="CREDIT";
    },
    open(){
      this.fetchRebateTypes();
      if(this.rebateToEdit!=null){
        this.rebate.value= this.rebateToEdit.value;
        this.rebate.type = this.rebateToEdit.type;
        this.rebate.netType = this.rebateToEdit.netType;
        this.rebate.creditType = this.rebateToEdit.creditType;
        if(this.rebate.creditType!=null){
          this.type = "CREDIT"
        }else{
          this.type="REBATE"
        }
      }
    },
    handleClose(){
      this.$emit('close');
      this.reset();
    },
    handleTypeChange(newType){
      if(newType=="REBATE"){
        this.rebate.creditType=null;
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    save(){

      this.$refs['rebateCreditForm'].validate((valid) => {
        if(valid){
          if(this.rebate.value==0){
            this.rebate.amount = null;
            this.rebate.value=null;
            this.rebate.netType = null;
            this.rebate.type = null;
            this.rebate.creditType = null;
          }
          this.rebate.userId=store.getters.user.id;
          this.$emit('update', {itemUuid:this.itemUuid, rebate:this.rebate});
          this.handleClose();
        }
      })

    },
    handleRebateTypeChange(newRebateType){
      if(newRebateType==1){
        this.rebate.netType="TOTAL";
      }
    },
    ...mapActions('controlData', ['fetchRebateTypes'])
	},
	computed: {
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "50%";
      }else{
        return "100%"
      }
    },
    ...mapState('controlData', ['rebate_types']),
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:60px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
